var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserLineSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.857,
    height: 7.714,
    viewBox: "0 0 6.857 7.714",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M12.846,6.6A1.8,1.8,0,1,0,11,4.8,1.824,1.824,0,0,0,12.846,6.6Zm0-3.086A1.286,1.286,0,1,1,11.527,4.8,1.3,1.3,0,0,1,12.846,3.514Z",
    transform: "translate(-9.418 -3)",
    fill: "#0d3148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M11.717,20.384a4.606,4.606,0,0,0-6.575,0A.507.507,0,0,0,5,20.736v1.353a.521.521,0,0,0,.527.514h5.8a.521.521,0,0,0,.527-.514V20.736A.507.507,0,0,0,11.717,20.384Zm-.388,1.7h-5.8V20.733a4.072,4.072,0,0,1,5.8,0Z",
    transform: "translate(-5 -14.888)",
    fill: "#0d3148"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserLineSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user_line_small.6a1a7dcca248ba6c5fa2d748da9e14f5.svg";